import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/common/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { PolicyService } from '../../../policy/policy.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-policies',
  templateUrl: './policies.component.html'
})
export class PoliciesComponent implements OnInit {

    @Input() clientKey: any;
    @Input() displayHeader: boolean = true;
    policies: any = [];

    constructor(public translate: TranslateService,
        private apiService: ApiService,
        private policyService: PolicyService,
        private route: ActivatedRoute,
        private router: Router) {
    }

    ngOnInit() {
        if (this.clientKey)
            this.getPolicies();
    }

    getPolicies() {
        var model = {
            ClientCde: this.clientKey,
            IsOfferOnlyInd: 'B',
            PageSize: 10,
            SortOrder: 'Desc',
            SortField: ''
        };

        var policySearchModel = {
            QuoteIndicator: 'N',
            ClientKey: this.clientKey,
            PageSize: 100,
            SortOrder: 'Desc'
        };

        this.apiService.post("Api/PolicyAPI/Search/", policySearchModel).subscribe((res: any) => {
            this.policies = res.rows;
        });

        //this.apiService.post("Api/QuoteApi/Search/", model).subscribe((result: any) => {
        //    var policies = [];

        //    for (var offerKey in result.rows) {
        //        if (result.rows[offerKey].PolExtCode &&
        //            result.rows[offerKey].PolStatusCde > 0 &&
        //            result.rows[offerKey].PolStatusCde != 4) {
        //            policies.push(result.rows[offerKey]);
        //        }
        //    }
        //    this.policies = policies;
        //});
    }

    goToPolicy(policy) {
        this.policyService.selectedPolicy = policy;
        //this.policyService.selectedProcessKey = policy.CreatedProcessCode;
        this.policyService.selectedProductKey = policy.PlanCode;
        this.policyService.selectedDepartmentKey = policy.DepartmentCode;
        this.policyService.userAction = 'consult';

        this.router.navigate(["../../../Policy/Edit"], { relativeTo: this.route });
    }

    //Used for scrollable cards
    public config: PerfectScrollbarConfigInterface = {
        suppressScrollX: false,
        wheelPropagation: false,
        useBothWheelAxes: true
    };

}
